export default {
  intro: {
    title: '何為聖杯擲筊',
    badge: '新手必讀',
    desc: '聖杯擲筊（又稱「擲筊」或「跋杯」）是閩南、臺灣及東南亞華人社會中常見的民間問事方式，已有數百年歷史。信眾雙手持兩片半月形木塊（筊杯），誠心默念所問之事後擲出，依據落地後的正反面組合來判讀神明旨意。',
    step0: '靜心默念：誠心將所問之事默念三遍，保持專注與虔誠',
    step1: '擲筊請示：點擊「誠心擲筊」，雙手擲出筊杯，等待結果',
    step2: '依象解讀：查看聖筊、陰筊或笑筊的結果，參考神明指引',
  },
};